import { DrawerBodyStyleConfig } from '../types';

export const styleConfig: DrawerBodyStyleConfig = {
  baseStyle: {
    px: '6',
    py: '2',
    flex: '1',
    overflow: 'auto',
  },
};
